<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<v-skeleton-loader
				style="max-width: 555px"
				width="100%"
				v-bind="attrs"
				type="card"
				v-if="isLoading"
			>
			</v-skeleton-loader>
			<div
				v-if="!isLoading"
				v-for="(file, index) in exhibitorUploads"
				:key="index"
				class="mt-1"
			>
				<div class="action-resources-page__file-container d-flex">
					<div class="d-flex">
						<div class="d-flex align-center">
							<PostAttachments :attachment="file" backgroundColor="#F3F3F6" />
						</div>
						<div class="action-resources-page__file-container__wrapper">
							<a
								class="action-resources-page__file-container__wrapper__title"
								:href="file.url"
								target="_blank"
							>
								{{ file.file_real_name }}
							</a>
							<span
								class="action-resources-page__file-container__wrapper__description"
							>
							</span>
						</div>
					</div>
					<span class="action-resources-page__file-container__wrapper__date mt-2">
						{{ dateCreated(file.time) }}
					</span>
				</div>
			</div>
		</v-card-text>
	</div>
</template>
<script>
import ButtonBack from '@/components/ButtonBack'
import ExhibitorFile from '@/components/Event/ExhibitorFile'
import Block from '@/mixins/Block.js'
import { mapGetters, mapActions } from 'vuex'
import Pagination from '@/components/Pagination.vue'
import PostAttachments from '@/components/Post/PostAttachments.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import PageBlocked from '@/components/PageBlocked.vue'

export default {
	components: {
		PageBlocked,
		NewsFeedEmpty,
		PostAttachments,
		Pagination,
		ButtonBack,
		ExhibitorFile,
	},
	mixins: [Block],
	data() {
		return {
			attrs: {
				elevation: 0,
				class: 'pt-7',
			},
		}
	},
	methods: {
		...mapActions('event', ['getExhibitorById']),
		...mapActions('app', ['setPageTitle']),
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			return date.toLocaleString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				timeZone: 'UTC',
			})
		},
	},
	mounted() {
		this.setPageTitle('Attachments')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	computed: {
		...mapGetters('event', ['isLoading', 'exhibitor']),
		groupId() {
			return parseInt(this.$route.query.group, 10) || 0
		},
		exhibitorUploads() {
			return this.exhibitor && this.exhibitor.uploads ? this.exhibitor.uploads : []
		},
	},
	created() {
		this.getExhibitorById({ id: +this.$route.params.id, groupId: this.groupId })
	},
}
</script>
<style lang="scss"></style>
